import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
import _ from "lodash";
import UConfirmDialog from "@/components/uikit/uComponents/UConfirmDialog.vue";
import UTable from "@/components/uikit/uComponents/UTable.vue";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useUser } from "@/composables/useAuth";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItParkListPage',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const user = useUser();
        const toast = useToast();
        const parkToPublishId = ref("");
        const profile = store.getters["profile/profile"];
        const isItParkRole = computed(() => {
            if (profile.roles) {
                return profile.roles.includes("ROLE_IT_PARK");
            }
            return false;
        });
        const breadcrumbItems = computed(() => [
            { label: "Dashborad", route: "/" },
            { label: "IT-Parks" }
        ]);
        onMounted(async () => {
            await store.dispatch("itPark/getItParks");
        });
        const itParks = computed(() => store.getters["itPark/itParks"]);
        const groupedItParks = computed(() => _.filter(itParks.value, (park) => !park.parent));
        const dataLoading = computed(() => store.getters["itPark/dataLoading"]);
        function getMenuItems(columnItem) {
            const ownerId = columnItem.owner.split("/")[3];
            const isOwner = ownerId == user?.id.toString();
            if (isOwner && isItParkRole) {
                if (columnItem.itParks.length == 0) {
                    return [
                        {
                            items: [
                                {
                                    label: "Edit",
                                    command: () => {
                                        router.push({
                                            name: "it park edit",
                                            params: { id: columnItem.id }
                                        });
                                    }
                                },
                                {
                                    label: "Publish",
                                    command: async () => {
                                        parkToPublishId.value = columnItem.id || "";
                                        openPublishDialog();
                                    }
                                },
                                {
                                    label: "Delete",
                                    class: "text-red-600",
                                    command: () => {
                                        store.dispatch("itPark/deleteItPark", columnItem.id);
                                    }
                                }
                            ]
                        }
                    ];
                }
                const child = itParks.value.find(x => x.id == _.split(columnItem.itParks[0], "/")[3]);
                if (new Date(child.updatedAt) > new Date(columnItem.updatedAt)) {
                    return [
                        {
                            items: [
                                {
                                    label: "Edit",
                                    command: () => {
                                        router.push({
                                            name: "it park edit",
                                            params: { id: columnItem.id }
                                        });
                                    }
                                },
                                {
                                    label: "Open",
                                    command: () => {
                                        router.push({
                                            name: "it park",
                                            params: { id: _.split(columnItem.itParks[0], "/")[3] }
                                        });
                                    }
                                },
                                {
                                    label: "Delete",
                                    class: "text-red-600",
                                    command: async () => {
                                        await store.dispatch("itPark/deleteItPark", _.split(columnItem.itParks[0], "/")[3]);
                                        await store.dispatch("itPark/deleteItPark", columnItem.id);
                                    }
                                }
                            ]
                        }
                    ];
                }
                return [
                    {
                        items: [
                            {
                                label: "Edit published",
                                command: () => {
                                    router.push({
                                        name: "it park edit",
                                        params: { id: _.split(columnItem.itParks[0], "/")[3] }
                                    });
                                }
                            },
                            {
                                label: "Edit draft",
                                command: () => {
                                    router.push({
                                        name: "it park edit",
                                        params: { id: columnItem.id }
                                    });
                                }
                            },
                            {
                                label: "Publish",
                                command: async () => {
                                    parkToPublishId.value = columnItem.id || "";
                                    openPublishDialog();
                                }
                            },
                            {
                                label: "Open",
                                command: () => {
                                    router.push({
                                        name: "it park",
                                        params: { id: _.split(columnItem.itParks[0], "/")[3] }
                                    });
                                }
                            },
                            {
                                label: "Delete",
                                class: "text-red-600",
                                command: async () => {
                                    await store.dispatch("itPark/deleteItPark", _.split(columnItem.itParks[0], "/")[3]);
                                    await store.dispatch("itPark/deleteItPark", columnItem.id);
                                }
                            }
                        ]
                    }
                ];
            }
            return [
                {
                    items: [
                        {
                            label: "Open",
                            command: () => {
                                router.push({ name: "it park", params: { id: columnItem.id } });
                            }
                        }
                    ]
                }
            ];
        }
        const publishDialog = ref();
        const openPublishDialog = () => {
            publishDialog.value?.openConfirmDialog();
        };
        async function publishItPark() {
            await store.dispatch("itPark/publishItPark", parkToPublishId.value);
            toast.success("IT-Park published successfully");
            await store.dispatch("itPark/getItParks");
        }
        const columns = [
            {
                property: "name",
                header: "Name"
            },
            {
                property: "itParks",
                header: "Published"
            },
            {
                property: "actions",
                header: "Actions",
                align: "right",
                type: "menu",
                menuFunction: getMenuItems
            }
        ];
        return (_ctx, _cache) => {
            const _component_UBreadcrumbs = _resolveComponent("UBreadcrumbs");
            const _component_UProgressBar = _resolveComponent("UProgressBar");
            const _component_UButton = _resolveComponent("UButton");
            const _component_UContent = _resolveComponent("UContent");
            const _component_UList = _resolveComponent("UList");
            return (_openBlock(), _createBlock(_component_UList, null, {
                default: _withCtx(() => [
                    _createVNode(_component_UBreadcrumbs, { items: breadcrumbItems.value }, null, 8, ["items"]),
                    (dataLoading.value)
                        ? (_openBlock(), _createBlock(_component_UProgressBar, {
                            key: 0,
                            green: "",
                            "is-loader": ""
                        }))
                        : (_openBlock(), _createBlock(_component_UContent, {
                            key: 1,
                            "has-title-delimiter": false
                        }, {
                            title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("span", null, "IT-Parks List", -1)
                                ]))]),
                            subtitle: _withCtx(() => [
                                _createElementVNode("span", null, "Number of parks: " + _toDisplayString(groupedItParks.value.length), 1)
                            ]),
                            "header-right": _withCtx(() => [
                                (isItParkRole.value)
                                    ? (_openBlock(), _createBlock(_component_UButton, {
                                        key: 0,
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push({ name: 'it park edit' })))
                                    }, {
                                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                _createTextVNode(" Add IT-Park ", -1)
                                            ]))]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                                _createVNode(UTable, {
                                    class: "w-full",
                                    loading: dataLoading.value,
                                    items: groupedItParks.value,
                                    columns: columns
                                }, {
                                    itParks: _withCtx(({ value }) => [
                                        (value.length == 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, " False "))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_2, " True "))
                                    ]),
                                    _: 1
                                }, 8, ["loading", "items"])
                            ]),
                            _: 1
                        })),
                    _createVNode(UConfirmDialog, {
                        ref_key: "publishDialog",
                        ref: publishDialog,
                        label: "Are you sure you want to publish IT Park?\nThis action cannot be undone.",
                        "accept-label": "Yes",
                        "reject-label": "No",
                        onAccept: publishItPark
                    }, null, 512)
                ]),
                _: 1
            }));
        };
    }
});
